import { render, staticRenderFns } from "./CardFeature.vue?vue&type=template&id=a330ac58&scoped=true"
import script from "./CardFeature.vue?vue&type=script&lang=js"
export * from "./CardFeature.vue?vue&type=script&lang=js"
import style0 from "./CardFeature.vue?vue&type=style&index=0&id=a330ac58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a330ac58",
  null
  
)

export default component.exports